export const mensajesChat = {
  // NewConversationModal.vue — start a new WhatsApp conversation
  newConversation: {
    nameTooShort: "Inserisci il nome con cui vuoi essere riconosciuto.",
    saveNameError: "Impossibile salvare il nome dell'attività.",
    started: "Conversazione avviata.",
    sent: "Messaggio inviato.",
    startError: "Impossibile avviare la conversazione.",
    titleConnect: "Collega il tuo WhatsApp",
    titleName: "Il nome della tua attività",
    titleNew: "Nuova conversazione",
    subtitleConnect: "Necessario per poter scrivere per primo",
    subtitleName: "Questo è il nome da cui le persone vedranno arrivare il messaggio",
    subtitleNew: "Scrivi a qualsiasi numero su WhatsApp",
    close: "Chiudi",
    senderStripPre: "Verrà inviato come",
    change: "Cambia",
    connectBody:
      "Per scrivere per primo, il messaggio deve provenire dal <strong>tuo numero WhatsApp Business</strong>. Con il numero condiviso di WACheckin le persone vedrebbero un telefono che non è il tuo e non potremmo presentarti con il nome della tua attività.",
    connectItem1: "Scrivi a qualsiasi numero, con o senza una prenotazione",
    connectItem2: "Il nome della tua attività appare come mittente",
    connectItem3: "Le risposte arrivano in questa stessa casella di posta",
    connectFoot: "Collega una sola volta, da Integrazioni → WhatsApp.",
    previewLabel: "Come lo vedranno",
    previewGreeting: "Ciao 👋",
    previewFromPre: "Ti stiamo scrivendo da",
    previewFromPost: ".",
    previewCtaPre: "Abbiamo un messaggio per te. Rispondi",
    previewOk: "Ok",
    previewCtaPost: "e te lo invieremo.",
    fallbackBusiness: "la tua attività",
    nameLabel: "Nome dell'attività",
    namePlaceholder: "Casale del Sole",
    nameHelp:
      "Viene salvato in Agente IA → Nuove prenotazioni e puoi modificarlo lì o qui quando vuoi.",
    recipientLabel: "Destinatario",
    messageLabel: "Messaggio",
    messagePlaceholder: "Scrivi il tuo messaggio…",
    cancelSoft: "Non ora",
    cancel: "Annulla",
    connectBtn: "Collega WhatsApp",
    continueBtn: "Continua",
    sendBtn: "Invia messaggio",
  },

  // MessageTranslate.vue — per-message translation in chat bubbles
  translate: {
    // BarraTraduccion.vue — la barra del traduttore della chat (automatico + anteprima)
    off: "Traduzione automatica disattivata",
    on: "Traduzione attiva",
    turnOn: "Tradurre quello che arriva e vedere prima quello che scrivi",
    turnOff: "Disattivare la traduzione automatica",
    guestWrites: "l'ospite scrive in {idioma}",
    nothingToDo: "Niente da tradurre: l'ospite scrive in {idioma}",
    youRead: "Lo leggi in",
    willBeSentIn: "quello che scrivi verrà inviato in",
    pickOutgoing: "In che lingua gli arriverà",
    theirs: "la sua",
    willArriveAs: "Gli arriverà così, in {idioma}:",
    sendIn: "Invia in {idioma}",
    cancel: "Annulla",
    discard: "Scarta",
    enterSends: "Con Invio parte",
    translating: "Traduzione in corso…",
    translate: "Traduci",
    viewTranslation: "Vedi traduzione",
    viewOriginal: "Vedi originale",
    translated: "Tradotto",
    copy: "Copia",
    copied: "Copiato",
    error: "Impossibile tradurre. Riprova.",
  },

  // Phone.vue — WhatsApp-style chatbot preview
  phone: {
    online: "Online",
    today: "Oggi",
    sampleQuestion: "A che ora è il check-in?",
    answerPlaceholder: "Scrivi qui la tua risposta...",
    inputPlaceholder: "Scrivi un messaggio...",
  },

  // selectorTypeIframe.vue — subscription billing period selector
  billing: {
    selectPeriod: "Scegli un periodo",
    selectPeriodHint: "Scegli come vuoi pagare",
    monthly: "Mensile",
    annual: "Annuale",
  },

  // GrupoDestinatarios.vue — escribir a un grupo de huéspedes
  grupo: {
    modeLabel: "A chi scrivi",
    modeOne: "Messaggio singolo",
    modeGroup: "Messaggio massivo",
    allOtas: "Tutte",
    needsWhatsapp: "Collega il tuo WhatsApp per usare questo canale",
    connectNow: "Collegalo",
    varsLabel: "Variabile",
    vars: {
      nombre: "Il nome dell'ospite",
      alojamiento: "Il nome dell'alloggio",
      entrada: "La data di arrivo",
      salida: "La data di partenza",
      codigo: "Il codice della prenotazione",
    },
    remove: "Rimuovi",
    oneEach: "Ogni ospite lo riceve una sola volta, tramite il primo canale disponibile.",
    noContact: "1 senza modo di contatto | {count} senza modo di contatto",
    otaLabel: "Quale OTA",
    emoji: "Emoji",
    attach: "Allega un file",
    noFileOta: "Il file non viaggia tramite l'OTA",
    previewLabel: "Come si leggerà",
    fileTooBig: "«{name}» pesa {size} MB e il massimo di WhatsApp per questo tipo è {max} MB",
    fileNotAllowed: "Si accettano solo immagini (JPG, PNG, GIF), PDF e video MP4: WhatsApp non riproduce altri formati.",
    attachHint: "Immagini e PDF fino a 10 MB · video MP4 fino a 15 MB",
    channelLabel: "Tramite",
    channels: { whatsapp: "WhatsApp", email: "E-mail", ota: "OTA" },
    groupLabel: "Quali ospiti",
    groups: {
      alojados: "Ora in struttura",
      entran_hoy: "Arrivano oggi",
      entran: "In arrivo",
      salen: "Partono oggi",
    },
    withinPre: "nei prossimi",
    withinPost: "giorno | giorni",
    empty: "Nessun ospite in questo gruppo al momento.",
    reachOf: "su {total} lo riceverà | su {total} lo riceveranno",
    queuedSilently: "1 non riceve alcun avviso oggi: ne aveva già uno in sospeso | {count} non ricevono alcun avviso oggi: ne avevano già uno in sospeso",
    noChannel: {
      whatsapp: "1 senza telefono | {count} senza telefono",
      email: "1 senza e-mail | {count} senza e-mail",
      ota: "1 senza conversazione OTA | {count} senza conversazione OTA",
    },
    billed: "1 conversazione WhatsApp viene addebitata | {count} conversazioni WhatsApp vengono addebitate",
    showList: "Vedi il destinatario | Vedi i {count} destinatari",
    hideList: "Nascondi l'elenco",
    noName: "Senza nome",
    states: {
      directo: "arriva",
      plantilla: "invito",
      en_cola: "ne aveva già uno",
      sin_telefono: "senza telefono",
      sin_correo: "senza e-mail",
      sin_hilo_ota: "senza conversazione",
      sin_contacto: "senza contatto",
    },
    sending: "Invio a 1 ospite | Invio a {count} ospiti",
    sendGroup: "Invia a 1 ospite | Invia a {count} ospiti",
    historial: {
      providerId: "Identificativo del fornitore. Serve per cercare il messaggio nella console SES.",
      sentMeans: "«Inviato» vuol dire che il fornitore l'ha accettato. Che l'ospite lo legga, o che non finisca nello spam, non dipende più da noi.",
      estados: {
        enviando: "In uscita",
        enviado: "Inviato",
        en_cola: "In coda",
        fallo: "Non inviato",
        sin_contacto: "Senza contatto",
      },
      title: "Invii di gruppo",
      subtitle: "Cosa è stato inviato, a chi e com'è andata per ciascuno",
      empty: "Non hai ancora inviato nessun messaggio di gruppo.",
      error: "Non è stato possibile caricare lo storico.",
      sentBy: "da {quien}",
      running: "In corso",
      back: "Indietro",
      messageLabel: "Il messaggio",
      recipientsLabel: "Destinatari",
      colName: "Ospite",
      colVia: "Canale",
      colDest: "Inviato a",
      colState: "Esito",
      openChat: "Apri",
      attachment: "Allegato: {nombre}",
      close: "Chiudi",
      reached: "{enviados} di {total}",
      noOne: "Senza nome",
    },
  },
};
